
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/finance-enquiry",
      function () {
        return require("private-next-pages/finance-enquiry/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/finance-enquiry"])
      });
    }
  